import { computed } from 'vue';
import { useCharacterDataStore } from '@/stores/character-data';
import { hasCost, type Priced } from '@/appdata/item-cost';

// Whether the CurrencyAdjuster has anything to do. Its hosts ask before they open it, and still
// decide where the open state lives: the store's `context` in the editor, a local ref in guided
// setup (owner's ruling 2026-09-28).
export function useCurrencyAdjuster() {
    const characterData = useCharacterDataStore();

    // A wealth-die build holds a die, not an amount, so there is nothing to add to or take away
    // (owner's ruling 2026-10-08). With no build options yet the type reads as funds, as the
    // sheet's header does.
    const adjustsFunds = computed(() => characterData.buildOptions?.startingFunds?.type !== 'wealth');

    // Adding or removing an item opens the adjuster only when there is money to move.
    const opensFor = (item: Priced): boolean => adjustsFunds.value && hasCost(item);

    return { adjustsFunds, opensFor };
}
